import { render, staticRenderFns } from "./PayPalIcon.vue?vue&type=template&id=34c7b1ec&scoped=true"
import script from "./PayPalIcon.vue?vue&type=script&lang=js"
export * from "./PayPalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c7b1ec",
  null
  
)

export default component.exports